import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addovertimetype',
  templateUrl: './addovertimetype.component.html',
  styleUrls: ['./addovertimetype.component.css']
})
export class AddovertimetypeComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;


  formname:String="Overtimetype"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;
//Edit Get Values
overtimetypeColl:any=[];
overtimetypeBO:any={};

overtimetypeid:number=0

overtimetypeform=new FormGroup({
  overtimetypeid:new FormControl(0),          
  overtimetype:new FormControl('',Validators.required),  
  rate:new FormControl(null,Validators.required), 
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.overtimetypeid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.overtimetypeform.reset();
       this.fnInitializeFormGroup(); 

       if(this.overtimetypeid>0){
         this.fngetOverTimeType();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.overtimetypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.overtimetypeform.setValue({
    overtimetypeid:0,    
    overtimetype:'',
    rate:null,
     inactive:false              
   })
}

//Get 
fngetOverTimeType() { 
  if (this.showProgress) {
    return;
  }        
     var data = {
       'overtimetypeid':this.overtimetypeid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getOverTimeType(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){ 
          this.fnHideProgress();
 
           this.overtimetypeColl=res.json().result;
           var editdata = this.overtimetypeColl[0];        
           this.fnEditMode(editdata);
           this.overtimetypeBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{  
      this.fnHideProgress();
        
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.overtimetypeform.valid){ this.saveloading = true;
         //Check
         var data = {
               'overtimetypeid': this.overtimetypeid,                      
               'overtimetype':this.overtimetypeform.get('overtimetype').value, 
               'rate':this.overtimetypeform.get('rate').value,
               'inactive':this.overtimetypeform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckOverTimeType(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.overtimetypeform.get('overtimetypeid').value>0){
                       //Update 
                       this.fnSetOverTimeType(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertOverTimeType(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){



                      this.saveloading = false;
                     
                       this.overtimetypeform.controls['overtimetype'].setErrors({'notfound': true});
                     }
               }
             }
             else {



              this.saveloading = false;
             
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertOverTimeType(data){    
 
   this.appService.fnInsertOverTimeType(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new overtimetype has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.overtimetypename);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetOverTimeType(data){    

this.appService.fnSetOverTimeType(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The overtimetype has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.overtimetypeid,data.overtimetypename);

             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/OverTimeType']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.overtimetypeform.setValue({ 
  overtimetypeid:deptBO.overtimetypeid,     
  overtimetype:deptBO.overtimetype,
  rate:deptBO.rate,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}










}
